import { Languages } from 'lucide-react';
import { SUPPORTED_LANGUAGES, type Language } from '@/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { cn } from '@/lib/utils';

const SHORT_LABELS: Record<Language, string> = { fr: 'FR', en: 'EN' };

/**
 * Bascule francais / anglais, presente sur toutes les pages.
 * French / English switch, present on every page.
 */
export function LanguageSwitcher({ className, compact = false }: { className?: string; compact?: boolean }) {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div
      role="group"
      aria-label={t('common.language')}
      className={cn('inline-flex items-center gap-0.5 rounded-xl border border-border bg-surface p-0.5', className)}
    >
      {!compact ? <Languages className="ml-1.5 h-4 w-4 text-ink-subtle" aria-hidden /> : null}
      {SUPPORTED_LANGUAGES.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
          className={cn(
            'rounded-lg px-2.5 py-1 text-xs font-semibold transition-colors',
            language === code ? 'bg-primary text-primary-ink' : 'text-ink-muted hover:bg-surface-muted hover:text-ink',
          )}
        >
          {SHORT_LABELS[code]}
        </button>
      ))}
    </div>
  );
}
